import React from 'react';
import {
  FooterContainer,
  Container,
  FooterContent,
  FooterSection,
  SocialLinks,
  FacebookIcon,
  ContactInfo,
  Schedule,
  FooterBottom,
  FooterBottomContent,
  ANPCBadge,
  BadgeContainer
} from './Footer.styles.jsx';

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterSection>
            <h3>Instalații Pro</h3>
            <p>Servicii profesionale de instalații sanitare și de încălzire cu garanție de calitate.</p>
            <SocialLinks>
              <a href="https://www.facebook.com/profile.php?id=61583427381552" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FacebookIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </FacebookIcon>
              </a>
              <button type="button" aria-label="Instagram" style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 'inherit', padding: 0 }}>📷</button>
              <button type="button" aria-label="LinkedIn" style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 'inherit', padding: 0 }}>💼</button>
            </SocialLinks>
          </FooterSection>

          <FooterSection>
            <h4>Servicii</h4>
            <ul>
              <li><a href="#servicii">Instalații Sanitare</a></li>
              <li><a href="#servicii">Încălzire Pardoseală</a></li>
              <li><a href="#servicii">Curățare Centrale</a></li>
              <li><a href="#servicii">Montaj Calorifere</a></li>
              <li><a href="#servicii">Reparații Instalații</a></li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h4>Contact</h4>
            <ContactInfo>
              <p>📞 <a href="tel:+40721150463">+40721150463</a></p>
              <p>📧 <a href="mailto:instalatii.pro@yahoo.com">instalatii.pro@yahoo.com</a></p>
              <p>📍 Ploiești, București și împrejurimi</p>
            </ContactInfo>
          </FooterSection>

          <FooterSection>
            <h4>Program</h4>
            <Schedule>
              <p>Luni - Vineri: 8:00 - 18:00</p>
              <p><strong>Urgențe: 24/7</strong></p>
            </Schedule>
          </FooterSection>
        </FooterContent>

        <FooterBottom>
          <FooterBottomContent>
            <p>&copy; 2025 Instalații Pro. Toate drepturile rezervate.</p>
            <BadgeContainer>
              <ANPCBadge>
                <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" aria-label="SAL - Sistemul de Alternative de Rezolvare a Litigiilor">
                  <img 
                    src="/SAL.svg" 
                    alt="SAL - Sistemul de Alternative de Rezolvare a Litigiilor" 
                    style={{ height: '40px', width: 'auto' }}
                  />
                </a>
              </ANPCBadge>
              <ANPCBadge>
                <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank" rel="noopener noreferrer" aria-label="SOL - Platforma Online de Rezolvare a Litigiilor">
                  <img 
                    src="/SOL.svg" 
                    alt="SOL - Platforma Online de Rezolvare a Litigiilor" 
                    style={{ height: '40px', width: 'auto' }}
                  />
                </a>
              </ANPCBadge>
            </BadgeContainer>
          </FooterBottomContent>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default Footer;

